module.exports = {
  CalculationDate: '01/07/2026',
  // FSSInsurancePremium: 243,
  InsurancePremium: 557.4,
  IncomeProtectionInsurancePremium: 0,

  EnforceMaximumContributionBase: true,

  WageInflationIndex: [0.037],
  PriceInflationIndex: [0.025],

  // current age, whole years
  AgeNow: 40,

  // if true, show age pension payments as the total for the household rather than the individual
  AgePensionAllowCouplePensions: true,

  // SGC, can be set higher or lower if an employer pays a different amount.
  // Note, if employer pays higher than SGC, but less than 12% then the contributions will be increased over tie to 12% in-line with the increases in SGC.
  // If the employer pays less than SGC then the exact employer rate will always be used.
  EmployerContributionRate: 0.12,

  // if true, force minimum drawings during drawdown phase. If false minimum drawing limits will be ignored.
  EnforceMinimumDrawingRequirements: true,

  // is the user a homeowner - used for age pension eligibility tests
  HomeOwner: true,

  // include age pensions payments in the output
  IncludeAgePension: true,

  // run a simple TTR strategy (attempt to match current take home pay while maximising Super contributions)
  IncludeTTR: false,

  // array of investment scenarios to be run. properties match pre-configured investment options defined in the model configuration
  InvestmentOption: 3,

  // as above, investment choice during the drawdown phase
  // note: array length should match InvestmentOption.length
  InvestmentOptionInRetirement: 3,

  // users marital status - used for age pension eligibility tests
  Married: true,

  // users other assets - used for age pension eligibility tests
  OtherAssets: 0,

  // users inome outside of super - used for age pension eligibility tests
  OtherIncome: 0,

  // one off contribution amount ($'s)
  OneOffContribution: 0,

  // one off contribution age (whole years only, must be greater or equal to current age and less than retirement age)
  OneOffContributionMadeAtAge: 40,

  // number of days per week worked (0 for career break) - can be any fraction of a work week
  PartTimeWorkDaysPerWeek: 0,

  // age at which part time work / career break commences (whole years only, must be greater or equal to current age and less than retirement age)
  PartTimeWorkFromAge: 40,

  // number of years of part time work / career break (whole years only, total duration cannot exceed time between current age and retirement age)
  PartTimeWorkYearsDuration: 0,

  // after tax (non-concessional) contributions ($'s / year)
  PostTaxMemberContributions: 0,

  // before tax (concessional) contributions ($'s / year)
  PreTaxMemberContributions: 0,

  // retirement age (must be greater or equal to the greater of preservation age or ageNow)
  RetirementAge: 67,

  // user salary ($'s / year)
  Salary: 70000,

  // user gender ("male" / "female")
  Sex: 'Female',

  // current super balance
  SuperannuationBalance: 100000,

  // target income (annual drawdown amount during retirement)
  TargetIncome: 50000,

  // value of any lumpsum withdrawal at retirement ($'s)
  WithdrawalAtRetirement: 0,

  EnforceSGCRatesOfContribution: true,

  // Investment options
  InvestmentOptions: {
    investmentOption_0: {
      id: 1,
      name: "Cash",
      grossReturn: 0.03,
      taxableFraction: 1,
      feePercentageOnBalance: 0,
      feePercentageOnContributions: 0,
      feePercentageOnBalanceCapped: 0.001,
      feePercentageOnBalanceCappedCap: 500,
      feeAnnualDollar: 65
    },
    investmentOption_1: {
      id: 2,
      name: "Low",
      grossReturn: 0.04,
      taxableFraction: 0.8333,
      feePercentageOnBalance: 0,
      feePercentageOnContributions: 0,
      feePercentageOnBalanceCapped: 0.001,
      feePercentageOnBalanceCappedCap: 500,
      feeAnnualDollar: 65
    },
    investmentOption_2: {
      id: 3,
      name: "Moderate",
      grossReturn: 0.06,
      taxableFraction: 0.5556,
      feePercentageOnBalance: 0,
      feePercentageOnContributions: 0,
      feePercentageOnBalanceCapped: 0.001,
      feePercentageOnBalanceCappedCap: 500,
      feeAnnualDollar: 65
    },
    investmentOption_3: {
      id: 4,
      name: "High",
      grossReturn: 0.07,
      taxableFraction: 0.4762,
      feePercentageOnBalance: 0,
      feePercentageOnContributions: 0,
      feePercentageOnBalanceCapped: 0.001,
      feePercentageOnBalanceCappedCap: 500,
      feeAnnualDollar: 65
    },
    custom: {
      id: 6,
      name: 'User defined',
      grossReturn: 0.046,
      taxableFraction: 0.8696,
      feePercentageOnBalance: 0,
      feePercentageOnContributions: 0,
      feePercentageOnBalanceCapped: 0.001,
      feePercentageOnBalanceCappedCap: 500,
      feeAnnualDollar: 65
    }
  },
};
